import { Box, Flex, Input } from '@sainsburys-tech/fable'
import React from 'react'

import { BatchTray, Shelf } from '../../enums/TemperatureCheckPosition'
import { ITemperatureData } from '../../types/ITemperatureData'
import {
  getCounterTemperatureValueByPosition,
  updateCounterTemperatureByValue,
} from '../../utils/hotFoodUtils'

interface IProps {
  className?: string
  counterNumber: number
  hasError: boolean
  currentTemp: ITemperatureData
  temperatures: ITemperatureData[]
  setTemperatures: (temperatures: ITemperatureData[]) => void
  isModal: boolean
  isFirstCheck?: boolean
  isBluetoothReading: boolean
}

const getTurboShelfLabel = (shelf: BatchTray | Shelf): string => {
  switch (shelf) {
    case Shelf.Top:
      return 'Top'
    case Shelf.Second:
      return '2nd'
    case Shelf.Third:
      return '3rd'
    case Shelf.Fourth:
      return '4th'
    case Shelf.Fifth:
      return '5th'
    default:
      return 'Unknown'
  }
}

const CounterTempCheckInputCard = (props: IProps) => {
  return (
    <Box
      backgroundColor='secondary'
      padding='none'
      data-testid='countertemp-input-card'
    >
      {/* each input box has different label according to Turbo-serve(Top, Middle, Bottom) */}
      <Flex
        direction='row'
        gap={props.isModal ? 'lg' : 'sm'}
        alignItems='center'
        style={{ maxWidth: '100%' }}
        shouldWrap={true}
      >
        <Input
          label={`Temperature (${getTurboShelfLabel(props.currentTemp.position)})`}
          hasHiddenLabel={true}
          autocomplete='off'
          className={props.className}
          inputProps={{
            id: `temperature-input-${props.counterNumber}${props.currentTemp.position}`,
          }}
          id={`temperature-input-${props.counterNumber}${props.currentTemp.position}`}
          onChange={(value) => {
            props.setTemperatures(
              updateCounterTemperatureByValue(
                value,
                props.currentTemp.position,
                props.temperatures,
              ),
            )
          }}
          placeholder='--.- ℃'
          type='text'
          inputMode='decimal'
          pattern='^\d{1,3}\.\d+$'
          value={getCounterTemperatureValueByPosition(
            props.currentTemp.position,
            props.temperatures,
          )}
          testid={`countertemp-input-${props.currentTemp.position}`}
          isReadOnly={props.isBluetoothReading}
          size={8}
          style={{
            width: '100%',
            margin: '10px auto',
          }}
        />
      </Flex>
    </Box>
  )
}

export default CounterTempCheckInputCard
